import axios from 'axios';
import {
  generateXB3TraceID, getAuthorizationToken,
  getChannelID, getHost, isB2CUser, isSsr
} from '../../utils/general';

const baseURL = getHost();
const channelId = getChannelID();

const TMXProfileID = isSsr
  ? ''
  : window.THD_ACCOUNT_LIB?.TMX?.getTMXsessionId();

const dgcConfig = {
  headers: {
    'x-client-id': `${isB2CUser() ? 'B2C' : 'B2B'}-MYACCOUNT-PREFERENCES`,
  }
};

const myAcctConfig = {
  baseURL,
  headers: {
    TMXProfileID,
    authorization: getAuthorizationToken(),
    channelId,
    'X-B3-TraceId': generateXB3TraceID()
  }
};

export const dgcClient = axios.create(dgcConfig);

dgcClient.interceptors.request.use(async (config) => {
  const clientId = `${isB2CUser() ? 'B2C' : 'B2B'}-MYACCOUNT-PREFERENCES`;
  const newConfig = config;
  newConfig.headers['x-client-id'] = clientId;
  return newConfig;
});

export const myAccountClient = axios.create(myAcctConfig);
